enum ANALYTICS_EVENTS {
  FOOTER_INTERACTION = 'spage user interaction',
  SURVEY_LOADED = 'spage loaded survey page',
  SURVEY_COMPLETE = 'spage completed survey',
}

enum ANALYTICS_INTERACTION_TYPE {
  CLICK = 'click',
}

enum ANALYTICS_WEBTYPE_TYPE {
  RESPWEB = 'respweb',
}

enum ANALYTICS_LOCATION {
  SURVEY_FOOTER = 'footer',
}

enum FOOTER_ANALYTICS_LINK_TEXT {
  POWERED_BY_CLICK = 'powered by',
  CREATE_SURVEY_CLICK = 'create a survey',
}

export {
  ANALYTICS_EVENTS,
  ANALYTICS_LOCATION,
  ANALYTICS_INTERACTION_TYPE,
  FOOTER_ANALYTICS_LINK_TEXT,
  ANALYTICS_WEBTYPE_TYPE,
};
